import { inMiniprograme, getWechatClientType } from '@/utils/device'
import { clientType } from '@/apis/api'

export default defineNuxtPlugin(() => {
  const mp = useState<boolean>('__mini_program__', () => false)

  if (import.meta.server) {
    try {
      const headers = useRequestHeaders(['user-agent'])
      const ua = (headers['user-agent'] || '').toLowerCase()
      mp.value = ua.includes('miniprogram') || ua.includes('mini program')
    } catch {
      mp.value = false
    }
  }

  if (mp.value) {
    inMiniprograme.value = true
    clientType.value = getWechatClientType(true)
  }
})
